// Axis ticks are rounded for readability; hover tooltips read from the
// underlying (unrounded) data, so they stay precise.
export function formatAxisValue(value: unknown): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return String(value);
  }

  return Number(value.toFixed(2)).toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
}
